
import { defineComponent, computed, ref } from "vue";

const themes = ["green", "white", "red", "purple"];
let idIncrement = 0;

export default defineComponent({
  emits: ["change"],
  props: {
    id: String,
    name: String,
    value: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
    additionalClasses: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: "green",
      validator: (value: string) => themes.some((v) => v === value),
    },
  },
  setup(props, { emit }) {
    const generatedId = ref("L-checkbox-" + idIncrement++);

    const forcedId = computed(() =>
      props.id === undefined ? generatedId.value : props.id
    );

    const handleValueChange = (e: Event) =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      emit("change", { name: props.name, value: (e.target as any).checked });

    return { forcedId, handleValueChange };
  },
});
